// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   Article Photos Viewer — Style aligné UtilisateurCompte
   + Image principale TRÈS GRANDE
   ========================================================= */

.lbv_container{
  position: relative;
  min-height: 100vh;
}

/* ✅ IMPORTANT : on réduit le padding du container uniquement ici
   (sinon 20% / 20% écrase l'image) */
.utilisateur_compte_container.lbv_container{
  padding-left: 6% !important;
  padding-right: 6% !important;
  padding-top: 2.5% !important;
}

/* Header */
.lbv_header{
  margin-top: 6px;
}

/* Zone image + nav */
.lbv_stage{
  margin-top: 14px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
}

/* Boutons nav */
.lbv_nav{
  width: 46px;
  height: 46px;
  border-radius: 999px;
  border: 1px solid #191818bf;
  background: rgba(255,255,255,.9);
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: transform .15s ease, background-color .2s ease, opacity .2s ease;
}

.lbv_nav i{
  font-size: 24px;
  color: var(--gris-principale);
}

.lbv_nav:hover{
  background: #fff;
  transform: translateY(-1px);
}

.lbv_nav:disabled{
  opacity: .45;
  cursor: not-allowed;
  transform: none;
}

/* ✅ Cadre image : prend beaucoup plus de place */
.lbv_main{
  width: auto;       /* ✅ plus large */
  border-radius: 18px;                   /* ✅ moins de padding = plus d'image */
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 90%;
}

/* ✅ Image : quasi plein écran (reste de la place pour thumbs) */
.lbv_main img{
  width: 100%;
  height: 600px;
  object-fit: contain;
  display: block;
  border-radius: 14px;
  background: #fff;
}

/* Bloc miniatures */
.lbv_thumbs_wrap{
  margin-top: 16px;
  margin-bottom: 16px;
}

.lbv_thumbs_title{
  justify-content: space-between;
  padding: 10px 14px;
  margin-bottom: 10px;
  border-radius: 12px;
}

.lbv_thumbs_title_left{
  display: flex;
  align-items: center;
}

.lbv_thumbs_title i{
  margin-right: 12px;
}

/* Grille thumbs */
.lbv_thumbs{
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;
}

.lbv_thumb{
  border: 2px solid transparent;
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
  padding: 0;
  cursor: pointer;
  box-shadow: 0 1px 10px rgba(0,0,0,.08);
  transition: transform .15s ease, border-color .15s ease;
}

.lbv_thumb img{
  width: 100%;
  height: 88px;                  /* un peu plus compact pour laisser + de place à l'image */
  object-fit: cover;
  display: block;
}

.lbv_thumb:hover{
  transform: translateY(-1px);
}

.lbv_thumb.active{
  border-color: var(--couleur-principale);
}

/* =========================================================
   Responsive
   ========================================================= */
/* =========================================================
   Responsive
   ========================================================= */
@media (max-width: 1100px){
  .utilisateur_compte_container.lbv_container{
    padding-left: 4% !important;
    padding-right: 4% !important;
  }

  .lbv_thumbs{
    grid-template-columns: repeat(5, 1fr);
  }

  /* ✅ l’image doit pouvoir rétrécir */
  .lbv_main{
    width: 100%;
  }

  .lbv_main img{
    width: 100%;
    height: auto;                 /* ✅ au lieu de 600px */
    max-height: calc(100vh - 340px);
  }
}

@media (max-width: 860px){
  .utilisateur_compte_container.lbv_container{
    padding-left: 3% !important;
    padding-right: 3% !important;
  }

  /* ✅ Zone image prend toute la largeur */
  .lbv_main{
    width: 100%;
  }

  .lbv_main img{
    width: 100%;
    height: auto;                 /* ✅ responsive */
    max-height: calc(100vh - 320px); /* ✅ un peu plus grand */
  }

  /* ✅ Miniatures en scroll horizontal (plus clean sur mobile) */
  .lbv_thumbs{
    display: flex;
    overflow-x: auto;
    gap: 10px;
    padding-bottom: 6px;
    -webkit-overflow-scrolling: touch;
  }

  .lbv_thumb{
    flex: 0 0 92px;
  }

  .lbv_thumb img{
    height: 92px;                 /* taille stable */
  }
}

`, "",{"version":3,"sources":["webpack://./src/assets/css/article/ArticlePhotosViewer.css"],"names":[],"mappings":"AAAA;;;8DAG8D;;AAE9D;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;qCACqC;AACrC;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,WAAW;AACX;EACE,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,2BAA2B;EAC3B,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,iDAAiD;AACjD;EACE,WAAW,QAAQ,iBAAiB;EACpC,mBAAmB,oBAAoB,sCAAsC;EAC7E,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,sCAAsC;EACtC,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,YAAY,mBAAmB,0DAA0D;EACzF,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;8DAE8D;AAC9D;;8DAE8D;AAC9D;EACE;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,qCAAqC;EACvC;;EAEA,oCAAoC;EACpC;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY,kBAAkB,uBAAuB;IACrD,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA,wCAAwC;EACxC;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY,kBAAkB,iBAAiB;IAC/C,+BAA+B,EAAE,wBAAwB;EAC3D;;EAEA,8DAA8D;EAC9D;IACE,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,iCAAiC;EACnC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY,kBAAkB,kBAAkB;EAClD;AACF","sourcesContent":["/* =========================================================\n   Article Photos Viewer — Style aligné UtilisateurCompte\n   + Image principale TRÈS GRANDE\n   ========================================================= */\n\n.lbv_container{\n  position: relative;\n  min-height: 100vh;\n}\n\n/* ✅ IMPORTANT : on réduit le padding du container uniquement ici\n   (sinon 20% / 20% écrase l'image) */\n.utilisateur_compte_container.lbv_container{\n  padding-left: 6% !important;\n  padding-right: 6% !important;\n  padding-top: 2.5% !important;\n}\n\n/* Header */\n.lbv_header{\n  margin-top: 6px;\n}\n\n/* Zone image + nav */\n.lbv_stage{\n  margin-top: 14px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n}\n\n/* Boutons nav */\n.lbv_nav{\n  width: 46px;\n  height: 46px;\n  border-radius: 999px;\n  border: 1px solid #191818bf;\n  background: rgba(255,255,255,.9);\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  transition: transform .15s ease, background-color .2s ease, opacity .2s ease;\n}\n\n.lbv_nav i{\n  font-size: 24px;\n  color: var(--gris-principale);\n}\n\n.lbv_nav:hover{\n  background: #fff;\n  transform: translateY(-1px);\n}\n\n.lbv_nav:disabled{\n  opacity: .45;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* ✅ Cadre image : prend beaucoup plus de place */\n.lbv_main{\n  width: auto;       /* ✅ plus large */\n  border-radius: 18px;                   /* ✅ moins de padding = plus d'image */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: 90%;\n}\n\n/* ✅ Image : quasi plein écran (reste de la place pour thumbs) */\n.lbv_main img{\n  width: 100%;\n  height: 600px;\n  object-fit: contain;\n  display: block;\n  border-radius: 14px;\n  background: #fff;\n}\n\n/* Bloc miniatures */\n.lbv_thumbs_wrap{\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n\n.lbv_thumbs_title{\n  justify-content: space-between;\n  padding: 10px 14px;\n  margin-bottom: 10px;\n  border-radius: 12px;\n}\n\n.lbv_thumbs_title_left{\n  display: flex;\n  align-items: center;\n}\n\n.lbv_thumbs_title i{\n  margin-right: 12px;\n}\n\n/* Grille thumbs */\n.lbv_thumbs{\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 10px;\n}\n\n.lbv_thumb{\n  border: 2px solid transparent;\n  border-radius: 14px;\n  overflow: hidden;\n  background: #fff;\n  padding: 0;\n  cursor: pointer;\n  box-shadow: 0 1px 10px rgba(0,0,0,.08);\n  transition: transform .15s ease, border-color .15s ease;\n}\n\n.lbv_thumb img{\n  width: 100%;\n  height: 88px;                  /* un peu plus compact pour laisser + de place à l'image */\n  object-fit: cover;\n  display: block;\n}\n\n.lbv_thumb:hover{\n  transform: translateY(-1px);\n}\n\n.lbv_thumb.active{\n  border-color: var(--couleur-principale);\n}\n\n/* =========================================================\n   Responsive\n   ========================================================= */\n/* =========================================================\n   Responsive\n   ========================================================= */\n@media (max-width: 1100px){\n  .utilisateur_compte_container.lbv_container{\n    padding-left: 4% !important;\n    padding-right: 4% !important;\n  }\n\n  .lbv_thumbs{\n    grid-template-columns: repeat(5, 1fr);\n  }\n\n  /* ✅ l’image doit pouvoir rétrécir */\n  .lbv_main{\n    width: 100%;\n  }\n\n  .lbv_main img{\n    width: 100%;\n    height: auto;                 /* ✅ au lieu de 600px */\n    max-height: calc(100vh - 340px);\n  }\n}\n\n@media (max-width: 860px){\n  .utilisateur_compte_container.lbv_container{\n    padding-left: 3% !important;\n    padding-right: 3% !important;\n  }\n\n  /* ✅ Zone image prend toute la largeur */\n  .lbv_main{\n    width: 100%;\n  }\n\n  .lbv_main img{\n    width: 100%;\n    height: auto;                 /* ✅ responsive */\n    max-height: calc(100vh - 320px); /* ✅ un peu plus grand */\n  }\n\n  /* ✅ Miniatures en scroll horizontal (plus clean sur mobile) */\n  .lbv_thumbs{\n    display: flex;\n    overflow-x: auto;\n    gap: 10px;\n    padding-bottom: 6px;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .lbv_thumb{\n    flex: 0 0 92px;\n  }\n\n  .lbv_thumb img{\n    height: 92px;                 /* taille stable */\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
